import FieldWrapper from '../fieldWrapper';
import CleanPasswordInput from '../../cleanPasswordInput';

export const ReduxFormCleanPasswordInput = FieldWrapper(CleanPasswordInput);
